"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formMessageStyles = void 0;
exports.formMessageStyles = {
    root: function () {
        return {
            paddingLeft: 0,
        };
    },
};
//# sourceMappingURL=formMessage-styles.js.map